import { render, staticRenderFns } from "./DateRangeExt.vue?vue&type=template&id=87a5a82c&scoped=true&"
import script from "./DateRangeExt.vue?vue&type=script&lang=js&"
export * from "./DateRangeExt.vue?vue&type=script&lang=js&"
import style0 from "./DateRangeExt.vue?vue&type=style&index=0&id=87a5a82c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87a5a82c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('87a5a82c')) {
      api.createRecord('87a5a82c', component.options)
    } else {
      api.reload('87a5a82c', component.options)
    }
    module.hot.accept("./DateRangeExt.vue?vue&type=template&id=87a5a82c&scoped=true&", function () {
      api.rerender('87a5a82c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-25xTK9ImJYlbc/JS/comp/DateRangeExt.vue"
export default component.exports